import ReactDOM from 'react-dom';
import Deposit from 'modules/Deposit/index';

ReactDOM.render(Deposit(), document.getElementById("main-root"));
